var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#979797",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 2.875v26.25c0 .52-.182.963-.547 1.328a1.808 1.808 0 0 1-1.328.547c-.52 0-.964-.182-1.328-.547L10.844 23.5H2.875c-.52 0-.964-.182-1.328-.547A1.808 1.808 0 0 1 1 21.625v-11.25c0-.52.182-.964.547-1.328A1.808 1.808 0 0 1 2.875 8.5h7.969l6.953-6.953A1.808 1.808 0 0 1 19.125 1c.52 0 .963.182 1.328.547.365.364.547.807.547 1.328zM30.531 24.253c2.27-1.833 3.722-5.89 3.722-9.034 0-3.682-1.188-6.599-3.564-8.75M35.946 26.946c3.05-2.463 5-7.912 5-12.137 0-4.946-1.596-8.865-4.788-11.755M25.723 21.973c1.525-1.231 2.5-3.956 2.5-6.068 0-2.474-.798-4.433-2.394-5.878"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.042628900dfe67a11ead10251cbb4b67.svg";
export { ForwardRef as ReactComponent };